<template>
  <pull-refresh
    style="min-height: 100vh"
    v-model="isLoading"
    @refresh="onRefresh"
  >
    <div class="page">
      <car-num
        :lot_id="lot_id"
        :show="show"
        @getPlateLicense="getPlateLicense"
      />
      <div class="unpayment">
        <div class="title">
          <div class="text">未支付订单</div>
          <div class="history-orders-nav" @click="gotoHistoryOrders">
            <span>查看历史订单</span>
            <van-icon class="arrow" name="arrow" />
          </div>
        </div>
        <div v-for="(item, index) in OrderData" :key="index" class="order-list">
          <div>
            <div class="card-plate">{{ item.car_no }}</div>
            <div class="card-title">进：{{ item.starttime }}</div>
          </div>
          <div>
            <div class="card-price">￥{{ item.pay_price }}</div>
            <Button
              plain
              color="#df665b"
              @click="onSelect(item.id, item.pay_price)"
              style="
                margin-bottom: 8px;
                height: 30px;
                width: 70px;
                font-size: 12px;
                line-height: 30px;
              "
              >去支付</Button
            >
          </div>
        </div>
      </div>
      <div class="unpayment">
        <div class="title">
          <div class="text">车辆列表</div>
        </div>
        <div v-for="(item, index) in CarData" :key="index" class="car-list">
          <div>
            <tag class="tag" type="danger">临时车</tag>{{ item.car_no }}
          </div>
          <div>
            <Button type="danger" class="del-button" @click="DelCar(item.id)"
              >删除</Button
            >
          </div>
        </div>
      </div>
      <div
        class="unpayment"
        v-if="
          userInfo.parking_coupon_status &&
            userInfo.parking_coupon_status === '1' &&
            version == 1
        "
      >
        <div class="titleBox">
          <div class="text">优惠券列表</div>
          <div style="width: 1rem" @click="onLookCouponList">
            <van-icon name="wap-nav" />
          </div>
        </div>
        <div
          v-for="(item, index) in couponList"
          :key="index"
          class="counpon-list"
        >
          <div class="counpon-list-item">
            <div>
              <img
                style="width: 3rem; height: 3rem; margin-right: 1rem"
                :src="item.img"
                alt="图片"
              />
            </div>
            <div>
              <div>
                {{ item.name }}
              </div>
              <div style="font-size: 0.8rem; color: red">￥{{ item.fee }}</div>
            </div>
          </div>
        </div>
      </div>
      <van-popup
        v-model="isShow"
        closeable
        round
        position="bottom"
        :style="{ height: '60%' }"
        class="popupList"
        @close="onClosePopup"
      >
        <van-checkbox-group v-model="radio" class="radioList">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in couponSelectList"
              :key="item.id"
              :title="`${item.name}：￥${item.coupon_price}`"
              clickable
              @click="onSelectCoupon(index)"
            >
              <template #right-icon>
                <van-checkbox
                  shape="square"
                  :name="item.id"
                  ref="checkboxes"
                  :disabled="
                    isDisabled &&
                      !radio.some(item2 => {
                        return item2 === item.id;
                      })
                  "
                />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <Button type="danger" class="button" @click="payment">确定</Button>
      </van-popup>
    </div>
  </pull-refresh>
</template>

<script>
import {
  getFacesList,
  unpaidOrder,
  addEntranceguard,
  delEntranceguard,
  payment,
  getCouponList,
  getAvailableCoupon,
  getVersion,
} from '../api/api';
import {
  Tag,
  Button,
  Toast,
  PullRefresh,
  Icon,
  Popup,
  Cell,
  CellGroup,
  Checkbox,
  CheckboxGroup,
} from 'vant';
import CarNum from '../components/CarNum';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {
    CarNum,
    Tag,
    Button,
    PullRefresh,
    VanIcon: Icon,
    VanPopup: Popup,
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanCheckbox: Checkbox,
    VanCheckboxGroup: CheckboxGroup,
  },
  data() {
    return {
      CarData: [],
      OrderData: [],
      show: false,
      isLoading: false,
      couponList: [],
      isShow: false,
      radio: [],
      couponSelectList: [],
      id: undefined,
      values: {},
      total_price: 0,
      isDisabled: false,
      payPrice: 0,
      version: '',
      lot_id: '',
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.carList();
    this.orderList();
    this.getVersion();
    if (
      this.userInfo.parking_coupon_status &&
      this.userInfo.parking_coupon_status === '1'
    ) {
      this.handleGetCouponList();
    }
    if (this.$route.query) {
      if (this.$route.query.lot_id) {
        this.lot_id = this.$route.query.lot_id;
      }
    }
  },
  methods: {
    async getVersion() {
      let { data } = await getVersion();
      this.version = data;
    },
    async onSelect(id, pay_price) {
      this.payPrice = parseFloat(pay_price);
      if (this.id !== id) {
        this.radio = [];
        this.total_price = 0;
        this.isDisabled = false;
      }
      if (
        this.userInfo.parking_coupon_status &&
        this.userInfo.parking_coupon_status === '1' &&
        this.version == 1
      ) {
        try {
          this.couponSelectList = [];
          const { data } = await getAvailableCoupon({ oid: id });
          this.couponSelectList = data;
          this.id = id;
          this.isShow = true;
        } catch {}
      } else {
        this.id = id;
        this.payment();
      }
    },
    async payment() {
      try {
        let value = { oid: this.id };
        if (
          this.userInfo.parking_coupon_status &&
          this.userInfo.parking_coupon_status === '1'
        ) {
          value.parking_coupon_log_id =
            this.radio && this.radio.length ? this.radio : undefined;
        }
        const { data } = await payment({
          ...value,
          is_prepaid: 1,
        });
        this.isShow = false;
        if (data.link_url) {
          window.location.href = data.link_url;
        } else {
          if (data === '支付成功') {
            Toast('支付成功');
            this.carList();
            this.orderList();
            if (
              this.userInfo.parking_coupon_status &&
              this.userInfo.parking_coupon_status === '1'
            ) {
              this.handleGetCouponList();
            }
          } else {
            this.pay(data);
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    onClosePopup() {
      this.isShow = false;
    },
    async handleGetCouponList() {
      try {
        const {
          data: { data },
        } = await getCouponList({ page: 1, pagesize: 5 });
        this.couponList = data;
      } catch (e) {
        console.log(e);
      }
    },
    pay(data) {
      let that = this;
      if ('WeixinJSBridge' in window) {
        return new Promise((resolve, reject) => {
          // eslint-disable-next-line
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            { ...data, debug: true },
            res => {
              if (res.err_msg === 'get_brand_wcpay_request:ok') {
                resolve();
                setTimeout(() => {
                  Toast('支付成功');
                }, 800);
                that.carList();
                that.orderList();
              } else {
                res.errMsg ? reject(new Error(res.errMsg)) : resolve();
              }
            }
          );
        });
      } else if ('AlipayJSBridge' in window) {
        // await onPayOffByAlipay(data);
        if (window.AlipayJSBridge) {
          that.onZFB(data.trade_no);
        } else {
          document.addEventListener(
            'AlipayJSBridgeReady',
            that.onZFB(data.trade_no),
            false
          );
        }
      }
    },
    onZFB(trade_no) {
      let that = this;
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line
        AlipayJSBridge.call('tradePay', { tradeNO: trade_no }, function(res) {
          if (res.resultCode === '9000') {
            resolve();
            Toast('支付成功');
            that.List();
          } else {
            reject(new Error(res.resultCode));
          }
        });
      });
    },
    onRefresh() {
      this.carList();
      this.orderList();
      setTimeout(() => {
        Toast('刷新成功');
        this.isLoading = false;
      }, 1000);
    },
    async orderList() {
      try {
        const { data } = await unpaidOrder();
        this.OrderData = data;
      } catch (e) {
        console.log(e);
      }
    },
    async carList() {
      try {
        const { data } = await getFacesList();
        this.CarData = data;
      } catch (e) {
        alert(e);
      }
    },
    async getPlateLicense(data, isRfid) {
      console.log(this.userInfo)
      if(this.userInfo.lot_id){
        this.lot_id = this.userInfo.lot_id
      }
      try {
        await addEntranceguard({
          car_no: data,
          is_rfid: isRfid,
          lot_id: this.lot_id,
        });
        Toast('添加成功');
        this.carList();
        this.orderList();
        this.show = true;
      } catch (e) {
        console.log(e);
      }
    },
    async DelCar(id) {
      try {
        const { message } = await delEntranceguard({ car_id: id });
        Toast('删除成功');
        this.carList();
        this.orderList();
      } catch (e) {
        console.log(e);
      }
    },
    onLookCouponList() {
      this.$router.push({
        name: 'Coupon',
      });
    },
    onSelectCoupon(index) {
      if (
        this.isDisabled &&
        !this.radio.some(item2 => {
          return item2 === this.$refs.checkboxes[index].name;
        })
      ) {
        return;
      }
      this.$refs.checkboxes[index].toggle();
      setTimeout(() => {
        this.total_price = 0;
        this.couponSelectList.forEach(item => {
          this.radio.forEach(item2 => {
            if (item.id === item2) {
              this.total_price =
                this.total_price + parseFloat(item.coupon_price);
            }
          });
        });
        if (this.total_price >= this.payPrice) {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      }, 100);
    },
    gotoHistoryOrders() {
      this.$router.push({
        name: 'HistoryOrders',
      });
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  height: 100%;
  background-color: #f1f1f1;
  padding-bottom: 1rem;
}
.unpayment {
  .title {
    margin-top: 1.85rem;
    padding: 1.75ex 1ex 1.75ex 1em;
    text-align: left;
    background-color: #fff;
    margin-bottom: 0.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
      font-weight: 700;
    }
    .history-orders-nav {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 4px;
      line-height: 22px;
      font-size: 14px;
      background-color: #fff;
      color: #333;

      .arrow {
        font-size: 14px;
        line-height: 18px;
        height: 18px;
      }

      &:active {
        opacity: 0.5;
      }
    }
  }
  .order-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .card-plate {
      text-align: left;
      font-size: 1rem;
      padding-bottom: 10rpx;
    }

    .card-title {
      font-size: 0.8rem;
      color: #8b8b8b;
      padding-left: 10rpx;
    }

    .card-price {
      font-size: 1rem;
      color: #858585;
      text-align: center;
    }
  }
  .car-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.1rem;
    .tag {
      margin-right: 0.5rem;
    }
    .del-button {
      height: 40px;
      width: 50px;
      padding: 0px 10px;
      font-size: 12px;
      margin-top: 5px;
      border-radius: 5px;
    }
  }
  .counpon-list {
    background-color: #fff;
    padding: 0.5rem 0.5rem;
    margin-bottom: 0.1rem;
    text-align: left;
    .counpon-list-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 0.5rem;
    }
  }
  .titleBox {
    margin-top: 1.85rem;
    padding: 1rem;
    text-align: left;
    background-color: #fff;
    margin-bottom: 0.1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
      font-weight: 700;
    }
  }
}
.popupList {
  .radioList {
    text-align: left;
    margin-top: 3rem;
    max-height: 75%;
    overflow-y: auto;
  }
  .button {
    position: fixed;
    bottom: 1rem;
    left: 0;
    width: 90%;
    border-radius: 50px;
    margin: 0 1rem;
  }
}
</style>
